import script from "./FreeAd.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeAd.vue?vue&type=script&setup=true&lang=js"

import "./FreeAd.vue?vue&type=style&index=0&id=ea171df2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea171df2"]])

export default __exports__